<template>
	<div class="vac-emoji-wrapper">
		<div
			class="vac-svg-button"
			:class="{ 'vac-emoji-reaction': emojiReaction }"
			@click="openEmoji"
		>
			<slot name="emoji-picker-icon">
				<img src="@/assets/svg-icons/smile.svg" />
			</slot>
		</div>

		<template v-if="emojiOpened">
			<transition name="vac-slide-up" appear>
				<div
					class="vac-emoji-picker"
					:class="{ 'vac-picker-reaction': emojiReaction, 'vac-picker-pc': pcMode }"
					:style="{
						height: `${emojiPickerHeight}px`,
            ...pickerStyle
					}"
				>
					<emoji-picker
						v-if="emojiOpened"
						ref="emojiPickerElement"
						:data-source="emojiDataSource"
						@emoji-click="addEmoji"
					/>
				</div>
			</transition>
		</template>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'

const props = defineProps({
  emojiOpened: { type: Boolean, default: false },
  emojiReaction: { type: Boolean, default: false },
  messageId: { type: String, default: '' },
  emojiDataSource: { type: String, default: undefined },
  pcMode: { type: Boolean, default: false }
})

const emojiPickerHeight = ref(320)
const pickerStyle = ref({})
const emojiPickerElement = ref(null)

const emit = defineEmits(['open-emoji', 'add-emoji'])

watch(() => props.emojiOpened, (val: boolean) => {
  if (val) {
    setTimeout(() => {
      addCustomStyling()
    }, 0)
  }
})

const addCustomStyling = () => {
	const picker = `.picker {
		border: none;
	}`

	const nav = `.nav {
		overflow-x: auto;
	}`

	const searchBox = `.search-wrapper {
		padding-right: 2px;
		padding-left: 2px;
	}`

	const search = `input.search {
		height: 32px;
		font-size: 14px;
		border-radius: 10rem;
		border: var(--chat-border-style);
		padding: 5px 10px;
		outline: none;
		background: var(--chat-bg-color-input);
		color: var(--chat-color);
	}`

	const style = document.createElement('style')
	style.textContent = picker + nav + searchBox + search
	emojiPickerElement.value?.shadowRoot?.appendChild(style)
}

const openEmoji = (ev: MouseEvent) => {
  emit('open-emoji')
  setEmojiPickerPosition(ev.clientY)
}

const setEmojiPickerPosition = (clientY: number) => {
  if (clientY < emojiPickerHeight.value + 30) {
    pickerStyle.value = {
      top: '32px'
    }
  }
}

const addEmoji = (e: CustomEvent) => {
  emit('add-emoji', {
    unicode: e.detail.unicode
  })
}
</script>

<style lang="scss">
.vac-emoji-wrapper {
	position: relative;
	display: flex;

	.vac-emoji-reaction svg {
		height: 19px;
		width: 19px;
	}

	.vac-emoji-picker {
		position: absolute;
		z-index: 9999;
		bottom: 36px;
		right: 20px;
		width: 300px;
		padding-top: 4px;
		overflow: scroll;
		box-sizing: border-box;
		border-radius: 0.5rem;
		background: #fff;
		box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.1),
			0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 2px 1px rgba(0, 0, 0, 0.1);
		scrollbar-width: none;

		&.vac-picker-pc {
			right: -50px;
			width: min(calc(100vw - 78px), 300px);
		}

		&::-webkit-scrollbar {
			display: none;
		}

		// &.vac-picker-reaction {
		// 	position: fixed;
		// 	top: initial;
		// 	right: initial;
		// }

		emoji-picker {
			height: 100%;
			width: 100%;
			--emoji-size: 24px; /* Width and height of all emoji */
			--emoji-padding: 4px;
			--background: var(--chat-emoji-bg-color);
			--border-color: var(--chat-sidemenu-border-color-search);
			--button-hover-background: var(--chat-sidemenu-bg-color-hover);
			--button-active-background: var(--chat-sidemenu-bg-color-hover);
		}

		@media screen and (max-width: 350px) {
			emoji-picker {
				--num-columns: 6;
			}
		}
	}
}
</style>
